import { render, staticRenderFns } from "./globalList.vue?vue&type=template&id=31c602d0&scoped=true&"
import script from "./globalList.vue?vue&type=script&lang=ts&"
export * from "./globalList.vue?vue&type=script&lang=ts&"
import style0 from "./globalList.vue?vue&type=style&index=0&id=31c602d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c602d0",
  null
  
)

export default component.exports